import { AuthStatusOptionModel } from "../data-model/authStatusOptions";
import { TableCellWithBadge } from "../data-model/tableCells";
import {
  getAuthStatusIdFromText,
  getBadgePropsForAuthStatus,
  MedicalPaOrdersAuthStatus,
} from "../enums/medicalPaOrdersAuthStatus";

export const formatAuthStatusBadge = (
  authStatus: string | null | undefined,
  authStatusOptions: AuthStatusOptionModel[],
): TableCellWithBadge => {
  const status =
    !authStatus || authStatus === "NA"
      ? MedicalPaOrdersAuthStatus.NotAvailable
      : authStatus;

  // Try to find by ID first
  let badgeProps = getBadgePropsForAuthStatus(authStatusOptions, status);

  // If not found, try to find by text
  if (!badgeProps && status !== MedicalPaOrdersAuthStatus.NotAvailable) {
    const statusId = getAuthStatusIdFromText(status, authStatusOptions);
    badgeProps = statusId
      ? getBadgePropsForAuthStatus(authStatusOptions, statusId)
      : authStatusOptions.find(
          (option) =>
            option.text?.toLowerCase() === status.toLowerCase() ||
            option.id?.toLowerCase() === status.toLowerCase(),
        );
  }

  const displayText =
    badgeProps?.text ??
    (status === MedicalPaOrdersAuthStatus.NotAvailable
      ? "Not Available"
      : status);

  return {
    text: badgeProps?.text ?? status,
    color: badgeProps?.textColor ?? "#0F0F0F",
    bgColor: badgeProps?.bgColor ?? "#F5F5F5",
    displayText,
  };
};
